<template>
  <div class="ui center aligned text container">
    <div class="winner-text">
      <h1 class="ui header">'t Is gebeurd!</h1>
      <h2 class="ui header">
        "{{ $store.getters.winningPlayer.name }}" wint deze finale!
      </h2>
    </div>
    <div
      class="ui vertical labeled icon massive orange buttons"
      v-if="$store.getters.isHost"
    >
      <div class="ui button" @click.once="showPlayScreen">
        <i class="left arrow icon"></i> Toon vorige antwoorden
      </div>
      <a class="ui button" :href="homePage" v-if="$store.getters.isHost">
        <i class="left home icon"></i> Terug naar home
      </a>
    </div>
    <div class="ui certificate segment">
      <h3 class="ui header">
        Oorkonde nodig?
        <div class="sub header">
          Klik op de oorkonde om een printklare PDF te downloaden:
        </div>
      </h3>
      <a href="http://bit.ly/2BKYjOL" target="_blank">
        <img class="ui centered rounded image" src="@/assets/certificate.jpg" />
      </a>
    </div>
  </div>
</template>

<script>
import sounds from '@/sounds';

export default {
  name: 'game-over',
  data() {
    return {
      homePage: process.env.VUE_APP_DSMTW_WEBSITE,
      hashtag: process.env.INSTAGRAM_TAG
    };
  },
  created() {
    sounds.play(sounds.AUDIO.VICTORY);
  },
  methods: {
    showPlayScreen() {
      this.$store.commit('SHOW_ROUND_PLAYSCREEN');
      this.$store.dispatch('syncGame');
    }
  }
};
</script>

<style scoped>
.winner-text {
  margin-bottom: 2em;
}
h1.ui.header {
  font-size: 6rem;
  font-weight: 500;
  margin-top: 2.6rem;
}
h2.ui.header {
  font-size: 3rem;
}
h3.ui.header {
  font-size: 3rem;
}
p {
  font-size: 1.5rem;
}
.ui.social.segment,
.ui.certificate.segment {
  margin-top: 4rem;
}
.ui.certificate.segment .ui.header {
  padding-top: 1rem;
}
.ui.social.segment h1.ui.header {
  padding-top: 3rem;
  padding-bottom: 0rem;
}
.ui.header .sub.header {
  font-size: 1.5rem;
}
.ui.social.segment h3.ui.header {
  margin-top: -1rem;
}
</style>
